import { useState, useEffect } from "react";

const nfEsAR = new Intl.NumberFormat("es-AR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

// Función que limpia lo que se va tipeando (solo dígitos, puntos, comas, guión)
function sanitizeTyping(value: string): string {
  return value.replace(/[^\d.,-]/g, "");
}

// Función que transforma un string con , o . en un número real
function parseLocaleNumber(value: string): number {
  if (!value) return NaN;
  let v = value.replace(/[^\d.,-]/g, "");

  const lastComma = v.lastIndexOf(",");
  const lastDot = v.lastIndexOf(".");
  const lastSep = Math.max(lastComma, lastDot);

  if (lastSep >= 0) {
    const intPart = v.slice(0, lastSep).replace(/[.,]/g, "");
    const fracPart = v.slice(lastSep + 1).replace(/[.,]/g, "");
    v = intPart + "." + fracPart;
  } else {
    v = v.replace(/\./g, "");
  }

  return Number(v);
}

export default function AmountInput({ payment, setPayment, translate }: any) {
  const [amountInput, setAmountInput] = useState("");

  useEffect(() => {
    const n = Number(payment?.Amount);
    setAmountInput(Number.isFinite(n) ? nfEsAR.format(n) : "");
  }, [payment?.Amount]);

  return (
    <div className="d-flex input-column mb-3">
      <label className="form-label">{translate.Amount}</label>

      <input
        type="text"
        inputMode="decimal"
        className="form-control"
        value={amountInput}
        onChange={(event) => {
          const cleaned = sanitizeTyping(event.target.value);
          setAmountInput(cleaned);
        }}
        onBlur={() => {
          const n = parseLocaleNumber(amountInput);
          if (Number.isNaN(n)) {
            setAmountInput("");
            setPayment({ ...payment, Amount: 0 });
            return;
          }
          setPayment({ ...payment, Amount: n });
          setAmountInput(nfEsAR.format(n));
        }}
        onPaste={(event) => {
          event.preventDefault();
          const pasted = (
            event.clipboardData || (window as any).clipboardData
          ).getData("text");
          const n = parseLocaleNumber(pasted);
          if (!Number.isNaN(n)) {
            setPayment({ ...payment, Amount: n });
            setAmountInput(nfEsAR.format(n));
          }
        }}
      />
    </div>
  );
}
